 'use client';

import Link from 'next/link';
import { useRouter } from 'next/navigation';
import React, { useState } from 'react';
 

export const UnauthenticatedLanding: React.FC = () => {
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const router = useRouter();

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const payloadCode = code.trim();
      const res = await fetch('/api/auth/registration-code/validate', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ code: payloadCode }),
      });
      if (res.ok) {
        router.push(`/auth/register?code=${encodeURIComponent(payloadCode)}`);
      } else {
        const data = await res.json().catch(() => ({} as any));
        const msg = data?.message ?? data?.error ?? 'Invalid registration code';
        setError(msg);
      }
    } catch {
      setError('Network error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="unauthenticated-landing" style={{ maxWidth: 480, margin: '0 auto', padding: '2rem' }}>
      <div className="logo" aria-label="Logo" style={{ textAlign: 'center', marginBottom: '1rem' }}>
        Korvo
      </div>
      <h1 style={{ textAlign: 'center' }}>Welcome to Korvo</h1>
      <form onSubmit={onSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem', marginTop: '1rem' }}>
        <label htmlFor="registration-code" style={{ fontSize: '0.9rem' }}>Registration Code</label>
        <input
          id="registration-code"
          value={code}
          onChange={(ev) => setCode(ev.target.value)}
          placeholder="Enter your registration code"
          required
          style={{ padding: '0.5rem', fontSize: '1rem' }}
        />
        <button type="submit" disabled={loading} style={{ padding: '0.75rem', fontSize: '1rem' }}>
          {loading ? 'Verifying...' : 'Continue'}
        </button>
      </form>
      {error && (
        <div role="alert" style={{ color: 'red', marginTop: '0.5rem' }}>
          {error}
        </div>
      )}
      <p style={{ textAlign: 'center', marginTop: '1rem' }}>
        Already have an account? <Link href="/auth/signin">Sign in</Link>
      </p>
    </div>
  );
};

export default UnauthenticatedLanding;
